import { AlertTriangle, CheckCircle2 } from 'lucide-react';

type StatusIndicatorProps = {
  errorCount: number;
};

// Status is always icon + text, never color alone.
export const StatusIndicator = ({ errorCount }: StatusIndicatorProps) =>
  errorCount === 0 ? (
    <span className="inline-flex items-center gap-1.5 rounded-full bg-emerald-50 px-2 py-0.5 text-xs font-medium text-emerald-800">
      <CheckCircle2 className="h-3.5 w-3.5" aria-hidden />
      Reconciled
    </span>
  ) : (
    <span className="inline-flex items-center gap-1.5 rounded-full bg-red-50 px-2 py-0.5 text-xs font-medium text-red-700">
      <AlertTriangle className="h-3.5 w-3.5" aria-hidden />
      {errorCount === 1 ? '1 problem' : `${errorCount} problems`}
    </span>
  );
